import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "container pb-5" }
const _hoisted_2 = { class: "row justify-content-center" }
const _hoisted_3 = { class: "col-12" }
const _hoisted_4 = { class: "card card-profile bg-secondary" }
const _hoisted_5 = { class: "row justify-content-center" }
const _hoisted_6 = { class: "col-lg-3 order-lg-2" }
const _hoisted_7 = { class: "card-profile-image" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "card-body pt-7 px-5" }
const _hoisted_10 = { class: "text-center mb-4" }
const _hoisted_11 = { class: "small" }
const _hoisted_12 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Unlock ")

import { useSocket } from "@/plugins/socket";
import { Form } from "vee-validate";
import Modal from "@/components/Modal.vue";
import { ref, computed, watch, onMounted } from "vue";
import { IStatus, PauseModule } from "@/store/modules/Pause";
import { AuthModule } from "@/store/modules/Auth";
import { ModalSidebarState as ModalState } from "@/types/components";
import { env } from "@/config";


export default /*#__PURE__*/_defineComponent({
  props: {
    open: { type: Boolean }
  },
  emits: ["changeModal"],
  setup(__props: any, { emit: emits }: { emit: ({
	(e: "changeModal", t: ModalState): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { open: boolean }

const socket = useSocket();
// props

// emits


const model = ref({
	password: "",
});
const reason = computed(() => PauseModule.reasonPause);
const user = computed(() => AuthModule.data.user);

watch(
	() => PauseModule.locked,
	(value, old) => {
		if (old && !value) {
			socket.client.emit("TICKET_LIST", { token: AuthModule.token });
			emits("changeModal", { show: false });
			// router.push({ path: "/omnichannel" });
		}
	}
);

onMounted(() => {
	PauseModule.setStatus(IStatus.CHATCENTER);
});

function onSubmit({ password }: { password: string }) {
	PauseModule.setLoading(true);
	socket.client.emit("SET_LISTO", { token: AuthModule.token, password });
}

return (_ctx: any,_cache: any) => {
  const _component_base_input = _resolveComponent("base-input")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_base_button = _resolveComponent("base-button")!

  return (_openBlock(), _createBlock(Modal, {
    show: props.open,
    "modal-classes": "modal-secondary",
    "body-classes": "py-0",
    style: {"animation-duration":"0.3s"},
    "modal-content-classes": "bg-none"
  }, {
    footer: _withCtx(() => []),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("img", {
                      src: _unref(user)?.picture,
                      class: "rounded-circle border-secondary"
                    }, null, 8, _hoisted_8)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("h3", null, _toDisplayString(_unref(user)?.name), 1),
                  _createElementVNode("h5", _hoisted_11, "Usuario en pausa " + _toDisplayString(_unref(reason)), 1)
                ]),
                _createVNode(_unref(Form), {
                  role: "form",
                  onSubmit: onSubmit
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_base_input, {
                      name: "password",
                      alternative: "",
                      "addon-left-icon": "ni ni-lock-circle-open",
                      type: "password",
                      placeholder: "Password",
                      modelValue: model.value.password,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((model.value.password) = $event))
                    }, null, 8, ["modelValue"]),
                    _createElementVNode("div", _hoisted_12, [
                      _createVNode(_component_router_link, {
                        class: "btn btn-link btn-secondary p-0",
                        to: _unref(env).requiredCallcenter ? '/callcenter' : '/user'
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(env).requiredCallcenter
												? "Regresar a CallCenter"
												: "Regresar a mi perfil"), 1)
                        ]),
                        _: 1
                      }, 8, ["to"]),
                      _createVNode(_component_base_button, {
                        class: "mt-2",
                        type: "primary",
                        "native-type": "submit",
                        loading: _unref(PauseModule).loading
                      }, {
                        default: _withCtx(() => [
                          _hoisted_13
                        ]),
                        _: 1
                      }, 8, ["loading"])
                    ])
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})